import { render, staticRenderFns } from "./my-choose.vue?vue&type=template&id=19772266&scoped=true&"
import script from "./my-choose.vue?vue&type=script&lang=js&"
export * from "./my-choose.vue?vue&type=script&lang=js&"
import style0 from "./my-choose.vue?vue&type=style&index=0&id=19772266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19772266",
  null
  
)

export default component.exports